import React, {useState, useRef} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Breadcrumb from 'layouts/main/Breadcrumb';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIDatePicker from "components/datepicker";
import codeDataStore from "common/codedata/store/CodeDataStore";
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import DateUtil from "utils/DateUtil";
import UISelect from "components/selectbox/UISelect";
function ContentsContainer() {
	const sectors1 = [
		'구매조건부신제품개발사업(공동R&D)','대·중소기업 혁신파트너십지원사업','대 중소 상생형 스마트공장','대·중소기업 해외동반진출 지원사업','동반성장몰_복지포인트 지원사업','성과공유제 확산 사업',
		'상생형 창업·벤처기업 지원사업','민간자율 기획사업','협력사 ESG 지원사업','동반성장 문화확산','동반성장 협력사 PR챌린지','지역사회 동반성장 지원사업','신용카드 영세가맹점 지원사업',
		'대·중소기업 안전보건 상생협력','기술유출 방지시스템','산업혁신운동','동반성장 복지포인트 지원사업','협력이 익공유제','원가절감 네트워크형 공동사업','상생협력기금조성·운영 관리 경비','기타 오입금(잘못 출연된 기금의 반환과제용)'
	]

	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const paramJson = useRef<string>("");
	const allParam = useRef<string>("");
	let pageNum = useRef<number>(1);

	const history = useHistory();
	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
	const [dateNum,setDateNum] = useState(0); //날짜 기본값



	/** 검색조건 */
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [donProcStsCd,setDonProcStsCd] = useState('');
	const [bizNm,setBizNm] = useState('');
	const [receipt,setReceipt] = useState('');
	const [tskNm,setTskNm] = useState('');
	const [tskReqNo,setTskReqNo] = useState('');
	const [bizCd,setBizCd] = useState('');
	//let bizCd = useRef<string>("");
	const [tskReqStsCd,setTskReqStsCd] = useState('');


	//초기 데이터 설정
	//let totalCnt:number = 0;
	let defaultRowCnt = 20;
	const rowCnt = useRef<string>("20");
	const totalCnt = useRef<string>("");

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init': {
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"Height": "auto"

			},
			Def: {
				Row: {
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			"Cols": [
				{"Header": "NO","Type": "Int",	"Name": "SEQ",	"RelWidth": "0.5","Align": "Center","CanEdit": 0},
				{"Header": "제출여부", "Type": "Text", "Name": "SUB_YN", "RelWidth": 1.2, "Align": "Center", "CanEdit": "0"},
				{"Header": "진행상태", "Type": "Html", "Name": "TSK_REQ_STS_NM", "RelWidth": 1.5, "Align": "Center", "CanEdit": "0",
					"Format": {
						'신청': '<label class="badge badge-22 blue">신청</label>',
						'접수완료': '<label class="badge badge-22 green">접수완료</label>',
						'수정요청': '<label class="badge badge-22 yellow">수정요청</label>',
						'변경심사': '<label class="badge badge-22 purple">변경심사</label>',
						'반려': '<label class="badge badge-22 red">반려</label>',
						'심사완료': '<label class="badge badge-22 gray">심사완료</label>'
					}
				},
				{"Header": "과제명", "Type": "Text", "Name": "TSK_NM", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "과제신청번호", "Type": "Text", "Name": "TSK_REQ_NO", "RelWidth": 2, "Align": "Center", "CanEdit": "0"},
				{"Header": "출연사업", "Type": "Text", "Name": "BIZ_NM", "RelWidth": 2, "Align": "Center" ,"CanEdit": "0"},
				{"Header": "신청일","Type": "Date","Name": "TSK_REQ_DATE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
				{"Header": "과제시작일","Type": "Date","Name": "TSK_ST_DATE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
				{"Header": "과제신청금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "집행금액","Type": "Int","Name": "PAY_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "미집행금액","Type": "Int","Name": "PAY_REMAIN_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제잔액","Type": "Int","Name": "SUPP_REMAIN_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "한도편입(오류종결)","Type": "Int","Name": "ERROR_CLO_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제종결","Type": "Text","Name": "TSK_CLO_YN","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "과제종료일","Type": "Date","Name": "TSK_EN_DATE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0", "DataFormat": "yyyy-MM-dd"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch('init');
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){

				if(evtParam.kind != "Header"){
					var sheet = evtParam.sheet;
					var row = sheet.getFocusedRow();
					sheet.selectRow( row, 1);
					let vTSK_REQ_NO = row["TSK_REQ_NO"].replaceAll('-', '');
					let vTSK_REQ_MODI_SEQ = row["TSK_REQ_MODI_SEQ"];
					let vAll_PARAM = allParam.current;

					let dataToSend = {vTSK_REQ_NO,vTSK_REQ_MODI_SEQ,vAll_PARAM};

					// 다른 페이지로 이동하면서 데이터 전달
					history.push({
						pathname: './usr_2107',
						state: { data: dataToSend }
					});
				}


			},
			onAfterSort:function(evtParam){
				// @ts-ignore
				sheet.goToPageByIndex(1);
				if(evtParam.sheet.getShownRows().length != 0){
					// @ts-ignore
					sheet.focus(evtParam.sheet.getShownRows()[0], "SEQ");
				}
			},
		    onRenderFinish : function(evtParam){
				if(receivedData !=undefined ){
					if(receivedData.PARAM_DATA != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.PARAM_PAGE);
					}
				}
    		},
			onMouseOver:function(evtParam){
				var sheet = evtParam.sheet;
				if (evtParam.row && evtParam.col && evtParam.orow && evtParam.ocol) {

					//console.log("이전 셀 값은 "+ sheet.getValue({row:evtParam.orow, col:evtParam.ocol}));
					//console.log("현재 셀 값은 "+ sheet.getValue({row:evtParam.row, col:evtParam.col}));
					//특정행의 글자를 붉은색으로 지정합니다..
					/*
					var row = evtParam.row;
					row["TextColor"] = "#297BF2";
					sheet.refreshRow(row);

					var oldrow = evtParam.orow;
					oldrow["TextColor"] = "#000000";
					sheet.refreshRow(oldrow);
					*/
				}
			},

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				pageNum.current = page; //페이지 번호 저장용
				paramSetting();

				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			if(receivedData !=undefined ){
				if(receivedData.PARAM_DATA != undefined){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
					options.Cfg.PageLength = receivedData.PARAM_ROW_CNT;
				}
			}

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "과제현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib.create();


		//필요한 공통코드 로딩.
		codeDataStore.read("[TRSC]", "cfms.portalBizCdList").then(() => {
			console.log("[TRSC]", codeDataStore.get("[TRSC]"))
		});


		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])


	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			receivedData.PARAM_ROW_CNT = e.target.value;
			pageNum.current = 1;
			rowCnt.current = e.target.value;
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();

		}else if(e.target.name === 'donProcStsCd'){
			setDonProcStsCd(e.target.value);
		}else if(e.target.name === 'bizNm'){
			setBizNm(e.target.value);
		}else if(e.target.name === 'receipt'){
			setReceipt(e.target.value);
		}
	};


	const paramSetting = () => {
		let PARAM_DATA = paramJson.current;
		let PARAM_PAGE = pageNum.current;
		let PARAM_ROW_CNT = rowCnt.current;
		let dataToSend = {PARAM_DATA, PARAM_PAGE, PARAM_ROW_CNT};

		allParam.current = JSON.stringify(dataToSend);

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2105',
			state: { data: dataToSend }
		});
	}

	const setSearchData = (type:string) => {
		let param:any = {};
		let sDt = DateUtil.toDateFormat(startDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(endDate, "YYYY-MM-DD");

		param = {
			"ST_DATE":sDt,
			"EN_DATE":eDt,
			"BIZ_CD" : bizCd,
			"TSK_REQ_STS_CD" : tskReqStsCd,
			"TSK_NM" : tskNm,
			"TSK_REQ_NO" : tskReqNo,
		};

		if(type == 'init'){
			//넘어온 파라미터 바인딩
			if(receivedData != undefined && receivedData.PARAM_DATA != undefined){
				param = JSON.parse(receivedData.PARAM_DATA);
				if(param.ST_DATE != '') setStartDate(new Date(param.ST_DATE));
				if(param.EN_DATE != '') setEndDate(new Date(param.EN_DATE));
				if(param.BIZ_CD != '') setBizCd(param.BIZ_CD);
				if(param.TSK_REQ_STS_CD != '') setTskReqStsCd(param.TSK_REQ_STS_CD);
				if(param.TSK_NM != '') setTskNm(param.TSK_NM);
				if(param.TSK_REQ_NO != '') setTskReqNo(param.TSK_REQ_NO);
				rowCnt.current = receivedData.PARAM_ROW_CNT;
				setShowRowCnt(Number(rowCnt.current));
			}
		}else{
			pageNum.current = 1;
		}

		paramJson.current = JSON.stringify(param);

		paramSetting();

		return param;
	}

	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {
		let param:any = {};

		param = setSearchData(sAction);

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'usr_2105',
			data: param
		})



		//전체데이터
		let result = response.REC;

		//전체ROW개수
		totalCnt.current = Object.keys(result).length+'';
		setTotalRowCnt(Object.keys(result).length);

		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		//데이터 처리
		ib.data = result;


		// @ts-ignore
		sheet.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore
		makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}

			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = Number(totalCnt.current) // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt.current; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(Number(sr) / Number(page)); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);
	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	//등록 페이지로 이동
	const pageCreate = function (){
		let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1202',
			state: { data: dataToSend }
		});
	}

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch('search');
		}
	}

	async function SetDate(value){
		const newEndDate = new Date();
		setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
		const newStartDate = new Date(newEndDate);
		newStartDate.setDate(newEndDate.getDate() - value);
		setStartDate(newStartDate);  // 시작 날짜를 조정
	}

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">과제현황</h1>
					<div className="sf sf-fund">
						<div className="inner">
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">신청기간</p>
								<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={startDate} valueChanged={(value) => setStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={endDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-root hz-gap5">
											<Button color={dateNum == 1 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(90); setDateNum(1); }}>이전 3개월</Button>
											<Button color={dateNum == 2 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(180); setDateNum(2); }}>이전 6개월</Button>
											<Button color={dateNum == 3 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(365); setDateNum(3); }}>이전 12개월</Button>
											<Button color={dateNum == 4 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(730); setDateNum(4); }}>이전 24개월</Button>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">과제신청번호</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={tskReqNo} valueChanged={(value) => setTskReqNo(value)} onKeyEnter={(e) => activeEnter(e)} placeholder={'과제신청번호를 입력하세요.'}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">과제명</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={tskNm} valueChanged={(value) => setTskNm(value)} onKeyEnter={(e) => activeEnter(e)} placeholder={'과제명을 입력하세요.'}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">출연사업</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<UISelect
											value={bizCd}
											valueChanged={(value) => setBizCd(String(value))}
											codeData={codeDataStore.get("cfms.portalBizCdList")}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">진행상태</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<UISelect
											codeData={codeDataStore.get("[TRSC]")}
											value={tskReqStsCd}
											valueChanged={(value) => setTskReqStsCd(String(value))}
											firstName={"all"}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="hz-root hz-center mb25">
						<Button color="pri" size="md" onClick={() => doSearch('search')}>조회</Button>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{totalRowCnt}</em>건</p>
						</div>
						<div className="hz-root hz-gap8">
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()}>다운로드</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" value={showRowCnt} onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>
					<div id='sheetDiv'>[D] IBSHEET 영역</div>
					<div id="pageNavi" className="pg"></div>

					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="pri" size="md" href={'/main/usr_2100/usr_2100'}>과제신청</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}

export default ContentsContainer;